export default __webpack_public_path__ + "static/media/particles-web-theme8.a9ebaa50.svg";